import { render, staticRenderFns } from "./recebimentoconta.vue?vue&type=template&id=0510f1f2"
import script from "./recebimentoconta.ts?vue&type=script&lang=js&external"
export * from "./recebimentoconta.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0510f1f2')) {
      api.createRecord('0510f1f2', component.options)
    } else {
      api.reload('0510f1f2', component.options)
    }
    module.hot.accept("./recebimentoconta.vue?vue&type=template&id=0510f1f2", function () {
      api.rerender('0510f1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/contareceber/recebimentoconta.vue"
export default component.exports